<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Luke Delaney</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="content-external-link">The Killing Boys</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><a class="content-external-link" href="http://ads.harpercollins.com/bobauk?isbn=9780007486076" target="_blank">Cold Killing</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://ads.harpercollins.com/bobauk?isbn=9780007486106" target="_blank">The Keeper</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://ads.harpercollins.com/bobauk?isbn=9780007486137" target="_blank">The Toy Taker</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://ads.harpercollins.com/bobauk?isbn=9780007585700" target="_blank">The Jackdaw</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://ads.harpercollins.com/bobauk?isbn=9780007585786" target="_blank">A Killing Mind</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="http://ads.harpercollins.com/bobauk?isbn=9780007585748" target="_blank">The Rule of Fear (standalone)</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-luke-delaney.vue?2b4faac8